import { useContext, useEffect } from 'react'

import { AuthenticationContext } from '../../providers/auth-provider'

// This screen is used to log the user out of the application. It exists for QA purposes since there is no log out button in the application. It is not a route that a user can navigate to.
const Logout = () => {
  const { handleLogout } = useContext(AuthenticationContext)

  useEffect(() => {
    handleLogout()
  }, [handleLogout])

  return null
}

export default Logout
